export default "__VITE_ASSET__BcT38rfJ__"